import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import LoginAs from '@components/LoginAs'
import LinkIcon from '@components/Icon/Link'

import { expertApi } from '@atheneum/api'

import ACL from '@components/ACL/ACL'
import Action from '@components/Action'
import { showDialog, isCancellationError } from '@components/Dialog'
import Activity from '@components/Icon/Activity'
import Add from '@components/Icon/Add'
import Block from '@components/Icon/Block'
import Delete from '@components/Icon/Delete'
import Edit from '@components/Icon/Edit'
import Experts from '@components/Icon/Experts'
import Lusha from '@components/Icon/Lusha'
import Tooltip from '@components/Tooltip'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ExpertProcessingStatus } from '../../components/ExpertBulkCreate/helpers/expertProcessingStatus'
import { ExpertFieldOptions } from '../../components/ExpertBulkCreate/helpers/expertFieldOptions'
import { ExpertOptionField } from '../../components/ExpertBulkCreate/helpers/expertOptionField'
import {
  AddToProcessingExpertTypeEnum,
  AddToProcessingActionEnum,
  sendAddToProcessingMetric,
  sendInitializeProcessingMetric,
  InitializeProcessingActionEnum
} from '../../components/ExpertBulkCreate/helpers/expertBulkCreate.metrics'
import { v4 as uuidv4 } from 'uuid'
class Actions extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    expert: PropTypes.object,
    history: PropTypes.object,
    expertStore: PropTypes.object,
    expertSearchStore: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    commentStore: PropTypes.object,
    expertBulkCreateStore: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      expertBulkProcessingStatus: null
    }

    this.bulkCreateEditIdentifier = `EDIT_${uuidv4()}`
    this.bulkCreateAddToProjectIdentifier = `ADD_TO_PROJECT_${uuidv4()}`

    this.processingExpertsDispose = props.expertBulkCreateStore.observeProcessingExperts(
      async experts => {
        if (
          experts.some(
            e =>
              e.customIdentifier === this.bulkCreateEditIdentifier ||
              e.customIdentifier === this.bulkCreateAddToProjectIdentifier
          )
        ) {
          this.setState((prevState, props) => {
            return {
              expertBulkProcessingStatus: ExpertProcessingStatus.Processing
            }
          })
        }
      }
    )

    this.completedExpertsDispose = props.expertBulkCreateStore.observeCompletedExperts(
      async experts => {
        const foundExpert = experts.find(
          e =>
            e.customIdentifier === this.bulkCreateEditIdentifier ||
            e.customIdentifier === this.bulkCreateAddToProjectIdentifier
        )
        if (foundExpert) {
          if (foundExpert.data.pdlId) {
            props.expertSearchStore.experts.replace(
              props.expertSearchStore.experts.filter(
                e => e.id != foundExpert.data.pdlId
              )
            )
          }

          this.setState((prevState, props) => {
            return {
              expertBulkProcessingStatus: ExpertProcessingStatus.Completed
            }
          })

          await props.expertStore.loadData(foundExpert.data.id)
          props.history.push(`/expert-search/expert/${foundExpert.data.id}`)

          if (
            foundExpert.customIdentifier ===
            this.bulkCreateAddToProjectIdentifier
          ) {
            props.modalStore.show({
              type: 'EXPERT_TO_PROJECT_FORM',
              props: {
                experts: [
                  { ...foundExpert.data, sherlock: props.expertStore.sherlock }
                ],
                isOneExpert: true
              }
            })
          }
        }
      }
    )

    this.errorExpertsDispose = props.expertBulkCreateStore.observeErrorExperts(
      async experts => {
        const foundExpert = experts.find(
          e =>
            e.customIdentifier === this.bulkCreateEditIdentifier ||
            e.customIdentifier === this.bulkCreateAddToProjectIdentifier
        )
        if (foundExpert) {
          this.setState((prevState, props) => {
            return {
              expertBulkProcessingStatus: ExpertProcessingStatus.Error
            }
          })
        }
      }
    )

    this.cancelledExpertsDispose = props.expertBulkCreateStore.observeCancelledExperts(
      async experts => {
        const foundExpert = experts.find(
          e =>
            e.customIdentifier === this.bulkCreateEditIdentifier ||
            e.customIdentifier === this.bulkCreateAddToProjectIdentifier
        )
        if (foundExpert) {
          this.setState((prevState, props) => {
            return {
              expertBulkProcessingStatus: ExpertProcessingStatus.Cancelled
            }
          })
        }
      }
    )
  }

  componentWillUnmount() {
    this.processingExpertsDispose()
    this.completedExpertsDispose()
    this.errorExpertsDispose()
    this.cancelledExpertsDispose()
  }

  onEditClick = async () => {
    const expertId = this.props.expert.id

    let expertToEdit = null

    if (expertId) {
      // Some kind of created expert (eg. standard expert, PDL)
      expertToEdit = { id: expertId }
    } else {
      // Not an expert (eg. AL item)
      expertToEdit = toJS(this.props.expert)
    }

    let expertTypeMetricDimension = null
    if (this.props.expert.id) {
      if (Number(this.props.expert.id)) {
        expertTypeMetricDimension =
          AddToProcessingExpertTypeEnum.EXISTING_EXPERT
      } else {
        expertTypeMetricDimension = AddToProcessingExpertTypeEnum.PDL
      }
    } else {
      if (this.props.expert.pdlId) {
        expertTypeMetricDimension = AddToProcessingExpertTypeEnum.PDL
      } else {
        expertTypeMetricDimension =
          AddToProcessingExpertTypeEnum.NON_EXISTING_EXPERT
      }
    }

    sendInitializeProcessingMetric(
      InitializeProcessingActionEnum.EXPERT_PAGE_EDIT
    )

    sendAddToProcessingMetric(
      AddToProcessingActionEnum.EXPERT_PAGE_EDIT,
      expertTypeMetricDimension
    )

    await this.props.expertBulkCreateStore.addExpertsToProcessingQueue(
      [
        {
          ...expertToEdit,
          bulkCreateCustomIdentifier: this.bulkCreateEditIdentifier
        }
      ],
      ExpertFieldOptions.EXPERT_CREATION_OPTIONS,
      ExpertOptionField.GetAllFields(),
      true,
      false,
      true
    )
  }

  onGetContactInfoClick = () => {
    this.props.modalStore.show({
      type: 'GET_CONTACT_INFO',
      props: {
        expert: this.props.expert,
        expertStore: this.props.expertStore
      }
    })
  }

  onAddExpertToProject = async () => {
    const { expert, growlStore, modalStore, expertStore } = this.props

    const expertId = this.props.expert.id

    let expertToAddToProject = null

    if (expertId) {
      // Some kind of created expert (eg. standard expert, PDL)
      expertToAddToProject = { id: expertId }
    } else {
      // Not an expert (eg. AL item)
      expertToAddToProject = toJS(this.props.expert)
    }

    let expertTypeMetricDimension = null
    if (this.props.expert.id) {
      if (Number(this.props.expert.id)) {
        expertTypeMetricDimension =
          AddToProcessingExpertTypeEnum.EXISTING_EXPERT
      } else {
        expertTypeMetricDimension = AddToProcessingExpertTypeEnum.PDL
      }
    } else {
      if (this.props.expert.pdlId) {
        expertTypeMetricDimension = AddToProcessingExpertTypeEnum.PDL
      } else {
        expertTypeMetricDimension =
          AddToProcessingExpertTypeEnum.NON_EXISTING_EXPERT
      }
    }

    sendInitializeProcessingMetric(
      InitializeProcessingActionEnum.EXPERT_PAGE_ADD_TO_PROJECT
    )

    sendAddToProcessingMetric(
      AddToProcessingActionEnum.EXPERT_PAGE_ADD_TO_PROJECT,
      expertTypeMetricDimension
    )

    await this.props.expertBulkCreateStore.addExpertsToProcessingQueue(
      [
        {
          ...expertToAddToProject,
          bulkCreateCustomIdentifier: this.bulkCreateAddToProjectIdentifier
        }
      ],
      ExpertFieldOptions.EXPERT_ADD_TO_PROJECT_OPTIONS,
      null,
      true,
      false,
      true
    )
  }

  onDeleteClick = () => {
    const { expert, history, growlStore } = this.props
    const { id, fullName } = expert
    return showDialog({
      title: 'Delete this expert?',
      text: fullName,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() => {
        return expertApi.remove(id)
      })
      .then(() => {
        growlStore.showSuccess(
          `${fullName}'s profile has been removed from the platform`,
          `Expert deleted from platform`
        )
        history.replace('/expert-search')
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(err, `Couldn't delete expert ${fullName}`)
      })
  }

  renderStatusDoNotContact = () => {
    return (
      <li
        className="action m-l-lg"
        onClick={() =>
          this.handleStatusChange({
            title: 'Do not contact status change comment',
            commentPrefix: 'do not contact reason: '
          })
        }>
        <Block />
        <span>Do not contact</span>
      </li>
    )
  }

  renderStatusAllowContact = () => {
    return (
      <ACL inline roles={['Admin', 'AdvancedExpertManagement']}>
        <li
          className="action m-l-lg"
          onClick={() =>
            this.handleStatusChange({ commentPrefix: 'allow contact reason: ' })
          }>
          <Activity />
          <span>Allow contacting</span>
        </li>
      </ACL>
    )
  }

  handleStatusChange = options => {
    this.props.modalStore.show({
      type: 'EXPERT_STATUS_CHANGE_COMMENT',
      props: {
        expert: this.props.expert,
        expertStore: this.props.expertStore,
        commentStore: this.props.commentStore,
        commentPrefix:
          options && options.commentPrefix
            ? options.commentPrefix
            : 'status change reason:',
        title:
          options && options.title ? options.title : 'Status change comment'
      }
    })
  }

  findSimilarExperts = () => {
    const { expertStore, expertSearchStore, history } = this.props
    const expertId = expertStore.expert.id
    const expertName = expertStore.expert.fullName
    const expert = [
      {
        value: expertId,
        label: expertName
      }
    ]
    expertSearchStore.query.similarTo.replace(expert)
    expertSearchStore.zoomTo = true
    history.push(`/expert-search/expert/${expertId}`)
  }

  render() {
    const { expertStore, staticData } = this.props
    const doNotContact = staticData.CONST.EXPERT_STATUSES.DO_NOT_CONTACT
    const expertName = expertStore.expert.fullName
    const shouldNotContact = expertStore.expertStatusId === doNotContact

    return (
      <div className="actions-wrapper actions-wrapper--space-between">
        <ul className="actions">
          {shouldNotContact ? null : (
            <li className="action" data-cy="add-to-project-btn">
              <Action
                disabled={
                  this.state.expertBulkProcessingStatus ===
                  ExpertProcessingStatus.Processing
                }
                onClick={() => {
                  if (
                    this.state.expertBulkProcessingStatus !==
                    ExpertProcessingStatus.Processing
                  ) {
                    this.onAddExpertToProject()
                  }
                }}>
                <Add />
                <span className="m-r-sm">Add/Invite to project</span>
              </Action>
              {this.state.expertBulkProcessingStatus ===
                ExpertProcessingStatus.Processing && (
                <CircularProgress
                  style={{ color: '#429bdc', width: '1.3em', height: '1.3em' }}
                />
              )}
            </li>
          )}
          <li className="action">
            <Action onClick={() => this.findSimilarExperts()}>
              <Tooltip
                tooltip={`Click to see other experts that have been submitted to client on the same projects as ${expertName}`}
                children={
                  <div>
                    <Experts className="icon__fill" />
                    <span>Similar experts</span>
                  </div>
                }
              />
            </Action>
          </li>
        </ul>
        <ul className="actions">
          {Number(this.props.expertStore.expert.id) ? (
            <li className="action">
              <Action onClick={this.onGetContactInfoClick}>
                <Lusha />
                <span>Get contact info</span>
              </Action>
            </li>
          ) : null}

          {shouldNotContact
            ? this.renderStatusAllowContact()
            : this.renderStatusDoNotContact()}

          {process.env.REACT_APP_LOGIN_AS_ALLOWED === 'true' &&
            !!Number(this.props.expertStore.expert.id) && (
              <ACL roles={['Admin']} inline>
                <li>
                  <LoginAs userId={this.props.expertStore.expert.id}>
                    <Action>
                      <LinkIcon />
                      <span>Login as</span>
                    </Action>
                  </LoginAs>
                </li>
              </ACL>
            )}

          <li className="action" data-cy="edit-expert-btn">
            <Action
              disabled={
                this.state.expertBulkProcessingStatus ===
                ExpertProcessingStatus.Processing
              }
              onClick={() => {
                if (
                  this.state.expertBulkProcessingStatus !==
                  ExpertProcessingStatus.Processing
                ) {
                  this.onEditClick()
                }
              }}>
              <Edit />
              <span className="m-r-sm">Edit</span>
              {this.state.expertBulkProcessingStatus ===
                ExpertProcessingStatus.Processing && (
                <CircularProgress
                  style={{ color: '#429bdc', width: '1.3em', height: '1.3em' }}
                />
              )}
            </Action>
          </li>
          {Number(this.props.expertStore.expert.id) ? (
            <ACL roles={['Admin', 'AdvancedExpertManagement']} action>
              <li className="action">
                <Action onClick={this.onDeleteClick}>
                  <Delete />
                  <span>Delete profile</span>
                </Action>
              </li>
            </ACL>
          ) : null}
        </ul>
      </div>
    )
  }
}

export default withRouter(
  inject(
    'modalStore',
    'staticData',
    'expertStore',
    'expertSearchStore',
    'growlStore',
    'expertBulkCreateStore'
  )(observer(Actions))
)
